/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.gpis-error-panel[_ngcontent-%COMP%] { color: red; padding: 5rem; font-weight: bold; }\r\n.description[_ngcontent-%COMP%]{display: -webkit-box;display: -ms-flexbox;display: flex;-webkit-box-pack: justify;-ms-flex-pack: justify;justify-content: space-between;-webkit-box-align: center;-ms-flex-align: center;align-items: center;}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovVXNlcnMvTlJFR0UzL1dvcmtzcGFjZS9PblByZW1DaGluYS9QYWNrSVRXZWJHdWkvc3JjL2FwcC9ub3JvbGVwYWdlL25vcm9sZXBhZ2UuY29tcG9uZW50LmNzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9DOi9Vc2Vycy9OUkVHRTMvV29ya3NwYWNlL09uUHJlbUNoaW5hL1BhY2tJVFdlYkd1aS9zcmMvYXBwL25vcm9sZXBhZ2Uvbm9yb2xlcGFnZS5jb21wb25lbnQuY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// C:/Users/NREGE3/Workspace/OnPremChina/PackITWebGui/src/$$_gendir/app/norolepage/norolepage.component.css.shim.ngstyle.ts